// === 5Star Wireless AI Chatbox with Firebase Logging ===
import { db } from "./firebase.js";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const chatBoxHTML = `
  <style>
    #chat-toggle-btn {
      position: fixed;
      bottom: 20px;
      right: 20px;
      background-color: #007bff;
      color: white;
      border: none;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      cursor: pointer;
      font-size: 22px;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
    }

    #chatgpt-widget {
      position: fixed;
      bottom: 90px;
      right: 20px;
      width: 330px;
      max-height: 550px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.2);
      display: none;
      flex-direction: column;
      overflow: hidden;
      z-index: 9999;
      opacity: 0;
      transform: translateY(20px);
      transition: all 0.3s ease;
    }

    #chatgpt-widget.visible {
      display: flex;
      opacity: 1;
      transform: translateY(0);
    }

    .chat-header {
      background: #00bfff;
      color: #000;
      padding: 16px;
      font-weight: bold;
    }

    #chatgpt-response {
      padding: 12px;
      font-size: 14px;
      height: 200px;
      overflow-y: auto;
      flex-grow: 1;
      background: #f7f7f7;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .chat-bubble {
      padding: 10px 14px;
      max-width: 80%;
      border-radius: 16px;
      word-wrap: break-word;
      line-height: 1.4;
    }

    .from-user {
      align-self: flex-end;
      background: #007bff;
      color: #fff;
      border-bottom-right-radius: 4px;
    }

    .from-bot {
      align-self: flex-start;
      background: #e5e5e5;
      color: #000;
      border-bottom-left-radius: 4px;
    }

    #chatgpt-input {
      width: calc(100% - 24px);
      margin: 10px 12px 0;
      padding: 8px;
      border-radius: 6px;
      border: 1px solid #ccc;
    }

    #chatgpt-send {
      background: #00b67a;
      color: #fff;
      border: none;
      margin: 8px 12px 12px;
      padding: 10px;
      width: calc(100% - 24px);
      border-radius: 6px;
      cursor: pointer;
    }

    .quick-replies {
      padding: 0 12px 12px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .quick-replies button {
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 6px;
      background: #f9f9f9;
      cursor: pointer;
    }

    .quick-replies button:hover {
      background: #f0f0f0;
    }
  </style>

  <button id="chat-toggle-btn" aria-label="Chat"><span id="chat-toggle-icon">💬</span></button>

  <div id="chatgpt-widget">
    <div class="chat-header">👋 Chat with us<br><small>Hi, message us with any questions. We're happy to help!</small></div>
    <div id="chatgpt-response"></div>
    <input id="chatgpt-input" type="text" placeholder="Write message" />
    <button id="chatgpt-send">Send</button>
    <div class="quick-replies">
      <button onclick="sendToChatGPT('What phones do you sell?')">What phones do you sell?</button>
      <button onclick="sendToChatGPT('Do you offer leasing options?')">Do you offer leasing options?</button>
      <button onclick="sendToChatGPT('Where is 5Star Wireless located?')">Where is 5Star Wireless located?</button>
    </div>
  </div>
`;

document.addEventListener("DOMContentLoaded", () => {
  document.body.insertAdjacentHTML("beforeend", chatBoxHTML);

  const toggleBtn = document.getElementById("chat-toggle-btn");
  const toggleIcon = document.getElementById("chat-toggle-icon");
  const chatWidget = document.getElementById("chatgpt-widget");
  const sendBtn = document.getElementById("chatgpt-send");

  let isOpen = false;

  toggleBtn.addEventListener("click", () => {
    isOpen = !isOpen;
    if (isOpen) {
      chatWidget.style.display = "flex";
      setTimeout(() => chatWidget.classList.add("visible"), 10);
      toggleIcon.textContent = "❌";
    } else {
      chatWidget.classList.remove("visible");
      setTimeout(() => chatWidget.style.display = "none", 300);
      toggleIcon.textContent = "💬";
    }
  });

  sendBtn.addEventListener("click", () => {
    const input = document.getElementById("chatgpt-input");
    const userText = input.value.trim();
    if (userText) {
      sendToChatGPT(userText);
      input.value = "";
    }
  });
});

async function sendToChatGPT(promptText) {
  const resBox = document.getElementById("chatgpt-response");

  const userBubble = document.createElement("div");
  userBubble.className = "chat-bubble from-user";
  userBubble.textContent = promptText;
  resBox.appendChild(userBubble);

  await addDoc(collection(db, "chat-messages"), {
    sender: "user",
    message: promptText,
    timestamp: serverTimestamp(),
  });

  const typingBubble = document.createElement("div");
  typingBubble.className = "chat-bubble from-bot";
  typingBubble.textContent = "Typing... ⏳";
  resBox.appendChild(typingBubble);
  resBox.scrollTop = resBox.scrollHeight;

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    const response = await fetch("https://5star-chatgpt-vercel-bot.vercel.app/api/chatgpt", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ prompt: promptText }),
      signal: controller.signal
    });

    clearTimeout(timeoutId);
    const data = await response.json();
    typingBubble.remove();

    const botBubble = document.createElement("div");
    botBubble.className = "chat-bubble from-bot";
    botBubble.textContent = data.reply || "⚠️ Bot didn’t return anything.";
    resBox.appendChild(botBubble);
    resBox.scrollTop = resBox.scrollHeight;

    await addDoc(collection(db, "chat-messages"), {
      sender: "bot",
      message: data.reply,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    typingBubble.remove();
    const errorBubble = document.createElement("div");
    errorBubble.className = "chat-bubble from-bot";
    errorBubble.textContent = `⚠️ ${err.name === "AbortError" ? "Request timed out." : err.message}`;
    resBox.appendChild(errorBubble);
    resBox.scrollTop = resBox.scrollHeight;
  }
}
